import React, { useEffect, useState } from 'react'
import { helper } from "lib/helper";
import {  Link } from 'react-router-dom';
import { Button, Card, CardHeader, Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, Table, UncontrolledTooltip } from 'reactstrap';
import BannerModal from "../../models/banner.model";
const Banner = () => {
    const [ modal, setModal] = useState(false);
    const [ modal1, setModal1] = useState(false);
    const [ modal5, setModal5] = useState(false);
    const [ data, setData]= useState();
    const[ image, setImage] = useState();
    const[id, SetId]= useState();

const EditBanner = async(event)=>{
    event.preventDefault();
    const form = new FormData(event.target);
    
    // Simulate editing banner
    setTimeout(() => {
        setData(prevData => ({
            ...prevData,
            data: {
                ...prevData.data,
                data: prevData.data.data.map(banner => 
                    banner.id === id 
                        ? {
                            ...banner,
                            title: form.get("title") || banner.title,
                            type: form.get("type") || banner.type,
                            link: form.get("link") || banner.link,
                            sequence: parseInt(form.get("sequence")) || banner.sequence
                        }
                        : banner
                )
            }
        }));
        helper.sweetalert.toast("Banner updated successfully", "success");
        toggleModal1();
    }, 500);
}




const AddBanner = (event) =>{
    event.preventDefault();
    const form = new FormData(event.target);
    
    // Simulate adding new banner
    const newBanner = {
        id: (data?.data?.data?.length + 1).toString(),
        title: form.get("title"),
        type: form.get("type"),
        status: "Active",
        link: form.get("link"),
        sequence: parseInt(form.get("sequence")) || 1,
        banner: {
            link: "https://via.placeholder.com/800x300/666666/FFFFFF?text=New+Banner"
        }
    };
    
    setTimeout(() => {
        setData(prevData => ({
            ...prevData,
            data: {
                ...prevData.data,
                data: [...(prevData?.data?.data || []), newBanner]
            }
        }));
        helper.sweetalert.toast("Banner added successfully", "success");
        toggleModal();
    }, 500);
}
const DeleteBanner= async (id)=>{
    // Simulate deleting banner
    setTimeout(() => {
        setData(prevData => ({
            ...prevData,
            data: {
                ...prevData.data,
                data: prevData.data.data.filter(banner => banner.id !== id)
            }
        }));
        helper.sweetalert.toast("Banner deleted successfully", "success");
    }, 500);
}
    const GetList = async()=>{
        // Dummy data for banners
        const dummyBannerData = {
            data: {
                data: [
                    {
                        id: "1",
                        title: "Welcome to Edushala - Best Online Learning Platform",
                        type: "tutor",
                        status: "Active",
                        link: "https://www.edushala.com/courses",
                        sequence: 1,
                        banner: {
                            link: "https://via.placeholder.com/800x300/0066FF/FFFFFF?text=Welcome+to+Edushala"
                        }
                    },
                    {
                        id: "2",
                        title: "Join as a Tutor - Teach and Earn",
                        type: "tutor",
                        status: "Active",
                        link: "https://www.edushala.com/become-tutor",
                        sequence: 2,
                        banner: {
                            link: "https://via.placeholder.com/800x300/FF6600/FFFFFF?text=Become+a+Tutor"
                        }
                    },
                    {
                        id: "3",
                        title: "Parent Guide - Support Your Child's Learning",
                        type: "parent",
                        status: "Active",
                        link: "https://www.edushala.com/parent-guide",
                        sequence: 3,
                        banner: {
                            link: "https://via.placeholder.com/800x300/00CC66/FFFFFF?text=Parent+Guide"
                        }
                    },
                    {
                        id: "4",
                        title: "JEE & NEET Preparation - Expert Guidance",
                        type: "tutor",
                        status: "Active",
                        link: "https://www.edushala.com/competitive-exams",
                        sequence: 4,
                        banner: {
                            link: "https://via.placeholder.com/800x300/9933CC/FFFFFF?text=JEE+NEET+Prep"
                        }
                    },
                    {
                        id: "5",
                        title: "Free Demo Classes Available",
                        type: "parent",
                        status: "Inactive",
                        link: "https://www.edushala.com/demo-classes",
                        sequence: 5,
                        banner: {
                            link: "https://via.placeholder.com/800x300/FF3366/FFFFFF?text=Free+Demo+Classes"
                        }
                    },
                    {
                        id: "6",
                        title: "24/7 Student Support - We're Here to Help",
                        type: "tutor",
                        status: "Active",
                        link: "https://www.edushala.com/support",
                        sequence: 6,
                        banner: {
                            link: "https://via.placeholder.com/800x300/33CCFF/FFFFFF?text=24x7+Support"
                        }
                    }
                ]
            }
        };
        
        setTimeout(() => {
            setData(dummyBannerData);
        }, 1000);
    }
    
    useEffect(()=>{GetList();},[])
    
    
    const toggleModal = () => {
        
        setModal(!modal);
    } 
    const toggleModal1 = () => {
        
        setModal1(!modal1);
    }
    const toggleModal5 = () => {
        console.log("hiii")
        setModal5(!modal5);
    } 
  return (
    <>
   <Container className="px-4 py-7">
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between ">
              <h3 className="mb-0">Banner List</h3>

              <div className="d-flex flex-row">
                <Button
                  size="sm"
                 onClick={toggleModal}
                  style={{ backgroundColor: "#080278", color: "white" }}
                  
                >
                  +Add
                </Button>
              </div>
            </CardHeader>
          </Card>
        </div>
      </Row>
      <Card className="shadow">
      <Table className="align-items-center table-flush" responsive>
      <thead className="thead-light">
        <tr>
              <th scope="col">S.NO</th>
              <th scope="col">Banner</th>
              <th scope="col">status</th>
              <th scope="col">Title</th>
              <th scope="col">Banner Type</th>
             
              <th scope="col">Banner Link</th>
              <th scope="col">
                Action
              </th>
              </tr>
              </thead>
             
    {data?.data?.data?.map((item, index)=>{
        console.log("banner",item)
        return (
        
          <tbody>
            <td key={index}>{index + 1}</td>
            <td ><img title="Click on me" src={item.banner.link} height="50px" width="80px" style={{border:"1px solid black",cursor:"pointer"}} onClick={()=>{
                setImage(item.banner.link);
                toggleModal5();}}/></td>
            <td>{item?.status}</td>
            <td>{item?.title}</td>
            <td scope="col">{item?.type}</td>
            
            <td>
            
           <p style={{cursor:"pointer"}}  onClick={() => window.open(item?.link, "_blank")} >{item?.link}</p>
          
            </td>
            <td>
              <Link
              onClick={()=>{
                toggleModal1()
                SetId(item?.id)}}
                style={{
                fontSize: "15px",
                color: "blue",
                alignItems: "center",
                display: "inline-block",
                borderRadius: "30%",
              
                }}
                id="eyeTooltip"
                
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </Link>

              <UncontrolledTooltip placement="top" target="userTooltip">
                Delete
              </UncontrolledTooltip>
              <p
                style={{
                  margin: "0 8px",
                  fontSize: "15px",
                  color: "red",
                  cursor:"pointer",
                 
                  // backgroundColor: "#f5f5f5",
                  display: "inline-block",
                  // padding: "5px", // Optional: Add padding for better appearance
                  borderRadius: "20%", // Optional: Make it a circle
                }}
                onClick={()=> {DeleteBanner(item.id);}}
                id="userTooltip"
              >
                <i className="fas fa-trash"></i>
              </p>
            </td>
            </tbody> 
          
        )
     })}
          
    </Table>
    </Card>
      {/*add banner module */}
      <Modal isOpen={modal} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          <h4> Add Banner </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={AddBanner}>
          <Row>
          <Col md={12}>
              <FormGroup>
                <Label> Select Banner</Label>
                <Input name="banner" type="file" placeholder="Enter Title" style={{border: "1px solid #cad1d7",borderRadius: "0.375rem", padding:"4px"}} />
              </FormGroup>
            </Col>
          </Row>
         
          <Row>

            <Col md={6}>
              <FormGroup>
                <Label>Title
                </Label>
                <Input type="text" name="title" placeholder="Enter Title" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                    Type
                </Label>
                <Input name="type" type="select" placeholder="Enter Vedio Type" >
                <option value="parent">Parent</option>
                <option value="tutor">Tutor</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
           {/* <Col md={6}>
              <FormGroup>
                z<Label>VideoName
                </Label>
                <Input type="text" placeholder="Enter videoname" />
              </FormGroup>
            </Col>*/}
            <Col md={6}>
              <FormGroup>
                <Label >Link
                </Label>
                <Input name="link" type="text" placeholder="Enter Description" />
              </FormGroup>
            </Col><Col md={6}>
              <FormGroup>
                <Label >Sequence
                </Label>
                <Input name="sequence" type="number" placeholder="Enter Description" />
              </FormGroup>
            </Col>
          </Row>
          
          
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
            {/* 
                    {addsLoadig ? (
                      <Loader color={"blue"} />
                    ) : ( */}
            <Button
              color="primary"
              type="submit"
              style={{
                float: "right",
                marginLeft: "5%",
                backgroundColor: "#080278",
                color: "white",
              }}
              
            >
              Save
            </Button>
          </div>
          </Form>
        </ModalBody>
      </Modal>
      {/*end*/}
       {/*Edit banner module */}
       <Modal isOpen={modal1} toggle={toggleModal1} size="lg">
        <ModalHeader toggle={toggleModal1}>
          <h4> Edit Banner </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={EditBanner}>
          <Row>
          <Col md={12}>
              <FormGroup>
                <Label> Select Banner</Label>
                <Input name="banner" type="file" placeholder="Enter Title" style={{border: "1px solid #cad1d7",borderRadius: "0.375rem", padding:"4px"}} />
              </FormGroup>
            </Col>
          </Row>
         
          <Row>

            <Col md={6}>
              <FormGroup>
                <Label>Title
                </Label>
                <Input type="text" name="title" placeholder="Enter Title" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                    Type
                </Label>
                <Input name="type" type="select" placeholder="Enter Vedio Type" >
                <option value="parent">Parent</option>
                <option value="parent">Tutor</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
           {/* <Col md={6}>
              <FormGroup>
                z<Label>VideoName
                </Label>
                <Input type="text" placeholder="Enter videoname" />
              </FormGroup>
            </Col>*/}
            <Col md={6}>
              <FormGroup>
                <Label >Link
                </Label>
                <Input name="link" type="text" placeholder="Enter Description" />
              </FormGroup>
            </Col><Col md={6}>
              <FormGroup>
                <Label >Sequence
                </Label>
                <Input name="sequence" type="number" placeholder="Enter Description" />
              </FormGroup>
            </Col>
          </Row>
          
          
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button color="secondary" onClick={toggleModal1}>
              Cancel
            </Button>
            {/* 
                    {addsLoadig ? (
                      <Loader color={"blue"} />
                    ) : ( */}
            <Button
              color="primary"
              type="submit"
              style={{
                float: "right",
                marginLeft: "5%",
                backgroundColor: "#080278",
                color: "white",
              }}
              
            >
              Save
            </Button>
          </div>
          </Form>
        </ModalBody>
      </Modal>
      {/*end*/}
      {/*popup Banner*/}
    <Modal isOpen={modal5} toggle={toggleModal5} size="lg">
      <ModalHeader toggle={toggleModal5}>
          <h4>Banner</h4>
        </ModalHeader>
        <ModalBody >
         
         <img src={image} width="750px" height="460px"  style={{ 
            maxWidth: "100%", // Makes the image scale within the container width
            height: "auto",   // Keeps the aspect ratio intact
            border: "2px solid gray"
          }} />
        </ModalBody></Modal>
    </Container>
  </>
  )
}

export default Banner
